var FastClick = require('fastclick/lib/fastclick.js');

var CheckDevice = {
    initialize () {
        var isHighDensity = this.isHighDensity()

        if (isHighDensity) {
            window.app.isRetina = true
            var html = document.querySelector('html')
            html.className = html.className + ' isRetina'
        }
    },

    isHighDensity () {
        return ((window.matchMedia && (window.matchMedia('only screen and (min-resolution: 124dpi), only screen and (min-resolution: 1.3dppx), only screen and (min-resolution: 48.8dpcm)').matches || window.matchMedia('only screen and (-webkit-min-device-pixel-ratio: 1.3), only screen and (-o-min-device-pixel-ratio: 2.6/2), only screen and (min--moz-device-pixel-ratio: 1.3), only screen and (min-device-pixel-ratio: 1.3)').matches)) || (window.devicePixelRatio && window.devicePixelRatio > 1.3))
    }
}

export default CheckDevice


// WEBPACK FOOTER //
// ./assets/app/front/utils/CheckDevice.js